<template>
	<div id="PageContact">
		<div class="wrapper-fluid bg-picture-darken small-nav">
			<Navigation />

			<div class="container content-contact">
				<div class="row">
					<div class="col-12">
						<div class="wrapper-headlines">
							<div class="row justify-content-center">
								<div class="col-md-12 col-lg-auto">
									<h1 class="d-inline-block">&nbsp;</h1>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-4 wrapper-rounded-content content-left">
						<div class="bg-blue-multiply rounded-corners mr15"></div>

						<div class="row justify-content-center headinline mr15">
							<div class="col-md-12">
								<div class="row">
									<div class="col-md-12">
										<h1 class="d-inline-block">{{page.hotlineHeadline}}</h1>
									</div>

									<div class="col-md-12" v-html="page.hotlineText">
										<!-- <p>Haben Sie Fragen oder benötigen Hilfe?</p> -->
									</div>

									<!-- <div class="col-md-12">
										<h3><i class="fa fa-mobile"></i> 0000-0000000<small>*</small></h3>
									</div>

									<div class="col-md-12">
										<p class="imprint"><small>* 1,24 € / Minute aus dem deutschen Festnetz. Kosten aus dem Mobilfunknetz deutlich höher. </small></p>
									</div> -->
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-8 wrapper-rounded-content">

						<div class="bg-blue-multiply rounded-corners"></div>

						<div class="row justify-content-center headinline">
							<div class="col-md-12">
								<h1 class="d-inline-block">{{page.contactHeadline}}</h1>

								<!-- <div class="row">
									<div class="col col-xs-12 col-md-6">
										<div class="btn-group">
											<Dropdown

											v-model="form.salutation"

											:buttonclass="'btn-light'"
											:buttontext="$t('Salutation')"
											:items="[{'label': $t('Mr.'), 'value': 'Mr.'},{'label': $t('Ms.'), 'value': 'Ms.'}]"
											></Dropdown>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-xs-6 col-md-6">
										<CsInput

										autocomplete="billing given-name"

										:placeholder="$t('Name')"
										:id="'name'"
										:name="'name'"
										v-model="form.name"
										></CsInput>
									</div>
									<div class="col-xs-12 col-md-6">
										<CsInput
										type="email"
										autocomplete="email"

										:validate="{'required':true, 'confirmed': 'emailConfirmed'}"

										:placeholder="$t('Email address')"
										:id="'email'"
										:name="'email'"
										v-model="form.email"
										></CsInput>
									</div>
								</div> -->
								<div class="row">
									<div class="col-md-12" v-html="page.contactText">

									</div>
									<!-- <div class="col-md-12">
										<CsTextarea

										:placeholder="$t('Your message')"
										:id="'feedback'"
										:name="'feedback'"
										:rows="8"
										v-model="form.feedback"
										></CsTextarea>

									</div> -->
									<!-- <p>Haben Sie Fragen oder benötigen Hilfe?</p> -->
								</div>
								<!-- <div class="row justify-content-center">
									<div class="col col-md-6">
										<button type="button" class="btn btn-primary btn-wp">
											{{ $t('Submit') }}
										</button>
									</div>
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
import find from 'lodash/find';
import { mapGetters } from 'vuex'
export default {
	name: 'PageContact',
	data() {
		return{
			// form: {
			// 	salutation: '',
			// 	name: '',
			// 	email: '',
			// 	feedback: '',
			// }
			page: {}
		}
	},
	methods: {
	
	},
	mounted() {
		var self = this;
			this.$store.dispatch('orm/GET_CONTACTPAGE')
			.then(result => {
				console.log('GET_CONTACTPAGE', result)
				self.page = result
			}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
	    	console.log(self.page);

	}
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/PageContact.vue